
import { useState, useContext, useEffect } from 'react';
import C from "helpers/HelpConstants";
import { HelpAbility } from "helpers/HelpAbility";
import EmailContext from "context/EmailContext";
import ErrorMessage from 'components/ErrorMessage';

const EMAIL_VALUES = {
    email: '', 
    numeroReportes: 0
}

function Form({ createEmail, updateEmail, setIsSearched}) {
    const { email: selectedEmail, setEmail: setSelectedEmail, message, setMessage } = useContext(EmailContext);

    const [form, setForm] = useState(EMAIL_VALUES);

    const { email, numeroReportes, primerReporte, ultimoReporte} = form;


    let myAbi = HelpAbility();
    const handleChange = (e) => {
        setForm({...form, [e.target.name]: e.target.value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let status = Object.keys(selectedEmail).length ? await updateEmail({ email: form, id: selectedEmail._id }) : await createEmail({ email: form })
        if (!status) {
            setIsSearched({
                search: '',
                option: '',
                state: false
            })
            setForm(EMAIL_VALUES)
            setSelectedEmail({});
            setMessage({ message: '', status: 200 })
        }
    }

    const handleReset = () => {
        setForm(EMAIL_VALUES)
        setSelectedEmail({});
        setMessage({ message: '', status: 200 })
    }


    const isVisibleForm = Object.keys(selectedEmail).length ? myAbi.has(C.A.EMAIL.UPDATE) : myAbi.has(C.A.EMAIL.CREATE);

    useEffect(() => {
        if (!Object.keys(selectedEmail).length) return null;
        setForm(selectedEmail)
        // eslint-disable-next-line
    }, [selectedEmail])

    return (
        <>
            {isVisibleForm
                &&

                <div className="mt-4">
                    <div className="row mb-2">
                        <h6>{Object.keys(selectedEmail).length ? 'Editar' : 'Agregar'} Correo</h6>
                    </div>
                    {message.status !== 200 && message.message && <ErrorMessage message={message.message}></ErrorMessage>}
                    <div className="rounded-3 p-3"
                        style={{ border: '1px solid black', paddingTop: '15px' }}>
                        <div className="d-flex justify-content-center">
                            <div className="col-3 themed-grid-col" style={{ paddingRight: '10px' }}>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Correo *</label>
                                    <input type="email" className="form-control" id="email"
                                        name="email" autoComplete="off" value={email} onChange={handleChange} placeholder="Ej. vcquispe@avatar-global.com" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="numeroReportes" className="form-label">Numero de Reportes</label>
                                    <input type="number" className="form-control" id="numeroReportes" name="numeroReportes" autoComplete="off" value={numeroReportes} onChange={handleChange}/>
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col" style={{paddingLeft: '10px', paddingRight: '10px'}}>
                                <div className="mb-3">
                                    <label htmlFor="primerReporte" className="form-label">Primer Reporte </label>
                                    <input type="date" className="form-control" id="primerReporte" name="primerReporte" autoComplete="off" value={primerReporte} onChange={handleChange}/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="ultimoReporte" className="form-label">Último Reporte</label>
                                    <input type="date" className="form-control" id="ultimoReporte" name="ultimoReporte" autoComplete="off" value={ultimoReporte} onChange={handleChange}/>
                                </div>
                            </div>

                            <div className="col-3 themed-grid-col ms-2" style={{ paddingLeft: '10px' }}>
                                <button className={'d-block d-block w-100 mb-2 btn btn-' + (true ? 'success' : 'primary')} type="submit" onClick={handleSubmit}><i className="bi bi-save" />{Object.keys(selectedEmail).length ? 'Actualizar' : 'Guardar'}</button>
                                <button type="reset" className="d-block w-100 btn btn-secondary" onClick={handleReset}><i
                                    className="bi bi-eraser" /> Limpiar
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default Form
